export interface NavItemProps {
  id: string;
  messageId: string;
  title: string;
  icon?: string;
  exact?: boolean;
  url?: string;
  type?: string;
  count?: number;
  color?: string;
  auth?: string[];
  children?: NavItemProps[] | NavItemProps;
}

const routesConfig: NavItemProps[] = [


  {
    id: 'dashboard',
    title: 'Dashboards',
    messageId: 'sidebar.dashboard',
    type: 'item',
    icon: '/assets/images/settings/DashboardIcon.png',
    url: '/dashboard'
  },

  {
    id: 'appointment',
    title: 'Appointment',
    messageId: 'sidebar.appointment',
    type: 'item',
    icon: '/assets/images/settings/AppointmentIcon.png',
    url: '/appointments'
  },

  {
    id: 'communication',
    title: 'Communication',
    messageId: 'sidebar.communication',
    type: 'collapse',
    icon: '/assets/images/settings/careoverview.png',
    children: [
      // {
      //   id: 'messages',
      //   title: 'Messages',
      //   messageId: 'sidebar.messages',
      //   type: 'item',
      //   url: '/messages'
      // },
      // {
      //   id: 'tasks',
      //   title: 'Tasks',
      //   messageId: 'sidebar.tasks',
      //   type: 'item',
      //   url: '/tasks'
      // },
      {
        id: 'notifications',
        title: 'Notifications',
        messageId: 'sidebar.notifications',
        type: 'item',
        url: '/notifications'
      },
    ]
  },
  {
    id: 'task',
    title: 'Task',
    messageId: 'sidebar.task',
    type: 'collapse',
    icon: '/assets/images/settings/tasklist.png',
    children: [
      {
        id: 'task-management',
        title: 'Task List',
        messageId: 'sidebar.taskList',
        type: 'item',
        url: '/task-management'
      },
      {
        id: 'task-create-practitioner',
        title: 'Create Practitioner Task',
        messageId: 'sidebar.createPractitionerTask',
        type: 'item',
        url: '/task-create-practitioner'
      },
      // {
      //   id: 'task-bin',
      //   title: 'Task Bin',
      //   messageId: 'sidebar.taskBin',
      //   type: 'item',
      //   url: '/task-bin'
      // },
    ]
  },
  {
    id: 'patient',
    title: 'Patients',
    messageId: 'sidebar.patient',
    type: 'item',
    icon: '/assets/images/settings/PatientsIcon.png',
    url: '/patients'
  },
  {
    id: 'referral',
    title: 'Referral',
    messageId: 'sidebar.referral',
    type: 'collapse',
    icon: '/assets/images/settings/ReferralsIcon.png',

    children: [
      {
        id: "oaktreeReferral",
        title: "Oaktree Referral",
        messageId: "sidebar.oaktreeReferral",
        type: "item",
        //icon: '/assets/images/patientsImages/referrals.png',
        url: "/oaktree-referral",
      },
      {
        id: "selfReferral",
        title: "Self Referral",
        messageId: "sidebar.selfReferral",
        type: "item",
        //icon: '/assets/images/patientsImages/referrals.png',
        url: "/self-referral",
      },
    ],
  },

  {
    id: 'review',
    title: 'Review & Ratings',
    messageId: 'sidebar.review',
    type: 'item',
    icon: '/assets/images/settings/ReviewsIcon.png',
    url: '/review-ratings',
  },
  // {
  //   id: 'statements',
  //   title: 'Statements',
  //   messageId: 'sidebar.statements',
  //   type: 'item',
  //   icon: '/assets/images/settings/BillingIcon.png',
  //   url: '/statements',
  // },
  {
    id: 'settings',
    title: 'Settings',
    messageId: 'sidebar.Settings',
    type: 'item',
    icon: '/assets/images/settings/SettingsIcon.png',
    url: '/settings'

  },
  {
    id: 'helpgroup',
    title: 'Help',
    messageId: 'sidebar.help',
    type: 'group',
    children: [

      {
        id: 'helpSupport',
        title: 'Help & Support',
        messageId: 'sidebar.HelpSupport',
        type: 'item',
        icon: '/assets/images/settings/help.png',
        url: '/helpSupport',
      },
    ]
  }



];
export default routesConfig;
